import 'core-js/fn/array/find-index';
import kanaUtil from '@/kana-util';
import RandomizedKana from '@/components/RandomizedKana';
import KanaChart from '@/components/KanaChart';
import StopWatch from '@/components/StopWatch';

const BEST_SCORE_KEY = 'kana-game:best';

export default {
  data() {
    const orderedKana = kanaUtil.getOrderedKana();
    const randomizedKana = kanaUtil.randomizedKana();

    return {
      orderedKana,
      randomizedKana
    };
  },

  components: {
    KanaChart,
    RandomizedKana,
    StopWatch
  },

  methods: {
    checkAnswer() {
      if(this.selectedKana && this.randomKana) {
        if(this.selectedKana.romaji === this.randomKana.romaji) {
          this.removeRandomKana(this.randomKana);
          this.randomKana = null;
          this.selectedKana.selected = false;
          this.selectedKana.correct = true;
          this.selectedKana = null;
        } else {
          const { selectedKana } = this;
          this.selectedKana.selected = false;
          this.selectedKana.wrong = true;
          setTimeout(() => {
            selectedKana.wrong = false;
          }, 1000);
          this.selectedKana = null;
        }
      }

      if(this.randomizedKana.flatten().length === 0 && this.$refs.stopwatch) {
        this.$refs.stopwatch.stop();
        this.storeScore(this.$refs.stopwatch.toTimestamp());
      }
    },

    storeScore(timeInSeconds) {
      const previousTime = localStorage.getItem(BEST_SCORE_KEY);

      if(previousTime === null || timeInSeconds < parseFloat(previousTime)) {
        localStorage.setItem(BEST_SCORE_KEY, timeInSeconds);
      }
    },

    removeRandomKana(kana) {
      // eslint-disable-next-line
      for(let colIndex = 0; colIndex < this.randomizedKana.length; colIndex++) {
        const col = this.randomizedKana[colIndex];
        const found = col.findIndex(k => k.romaji === kana.romaji);
        if(found > -1) {
          col.splice(found, 1);
          return true;
        }
      }
      return false;
    },

    onFirstKanaSelection() {
      if(this.$refs.stopwatch) {
        this.$refs.stopwatch.start();
      }
    },

    onKanaChartSelected(data) {
      const { kana } = data;

      if(this.selectedKana && this.selectedKana.romaji !== kana.romaji) {
        return;
      }

      kana.selected = !kana.selected;

      if(kana.selected) {
        this.selectedKana = kana;
        this.checkAnswer();
      } else {
        this.selectedKana = null;
      }
    },

    onRandomKanaSelected(data) {
      const { kana } = data;

      if(this.randomKana && this.randomKana.romaji !== kana.romaji) {
        return;
      }

      kana.selected = !kana.selected;

      if(kana.selected) {
        this.randomKana = kana;
        this.checkAnswer();
      } else {
        this.randomKana = null;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/KanaSelectionMixin.js